export default commomImport => [{
  path: `business-manager`,
  name: 'BusinessManager',
  meta: {
    title: 'store.businessManager'
  },
  //  全部订单
  component: commomImport('store-manager/business-manager')
}];
